"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSchema = void 0;
exports.TableSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/table.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Table",
    "description": "Add a textual table with rows and columns",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:table"
            ]
        },
        "caption": {
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        },
        "fields": {
            "type": "array",
            "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                    "markup": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "name": {
                        "type": "string",
                        "description": "Must match with one of rows[].key"
                    },
                    "title": {
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    }
                },
                "required": [
                    "name",
                    "title"
                ]
            }
        },
        "rows": {
            "type": "array",
            "items": {
                "type": "object",
                "additionalProperties": {
                    "anyOf": [
                        {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                        },
                        {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                        }
                    ]
                }
            }
        }
    },
    "required": [
        "fields",
        "rows",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFibGUuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy90YWJsZS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxXQUFXLEdBQUc7SUFDekIsS0FBSyxFQUFFLDhEQUE4RDtJQUNyRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxPQUFPO0lBQ2hCLGFBQWEsRUFBRSwyQ0FBMkM7SUFDMUQsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sa0JBQWtCO2FBQ25CO1NBQ0Y7UUFDRCxTQUFTLEVBQUU7WUFDVCxNQUFNLEVBQUUsNkRBQTZEO1NBQ3RFO1FBQ0QsUUFBUSxFQUFFO1lBQ1IsTUFBTSxFQUFFLE9BQU87WUFDZixPQUFPLEVBQUU7Z0JBQ1AsTUFBTSxFQUFFLFFBQVE7Z0JBQ2hCLHNCQUFzQixFQUFFLEtBQUs7Z0JBQzdCLFlBQVksRUFBRTtvQkFDWixRQUFRLEVBQUU7d0JBQ1IsTUFBTSxFQUFFLE9BQU87d0JBQ2YsT0FBTyxFQUFFOzRCQUNQLE1BQU0sRUFBRSxRQUFRO3lCQUNqQjtxQkFDRjtvQkFDRCxNQUFNLEVBQUU7d0JBQ04sTUFBTSxFQUFFLFFBQVE7d0JBQ2hCLGFBQWEsRUFBRSxtQ0FBbUM7cUJBQ25EO29CQUNELE9BQU8sRUFBRTt3QkFDUCxNQUFNLEVBQUUsNkRBQTZEO3FCQUN0RTtpQkFDRjtnQkFDRCxVQUFVLEVBQUU7b0JBQ1YsTUFBTTtvQkFDTixPQUFPO2lCQUNSO2FBQ0Y7U0FDRjtRQUNELE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE1BQU0sRUFBRSxRQUFRO2dCQUNoQixzQkFBc0IsRUFBRTtvQkFDdEIsT0FBTyxFQUFFO3dCQUNQOzRCQUNFLE1BQU0sRUFBRSxRQUFROzRCQUNoQixNQUFNLEVBQUUsNkRBQTZEO3lCQUN0RTt3QkFDRDs0QkFDRSxNQUFNLEVBQUUsUUFBUTs0QkFDaEIsTUFBTSxFQUFFLG1GQUFtRjt5QkFDNUY7cUJBQ0Y7aUJBQ0Y7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixRQUFRO1FBQ1IsTUFBTTtRQUNOLE1BQU07S0FDUDtDQUNGLENBQUEifQ==